// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"344":"82f0e5c3","969":"0f1f5b5e"}[chunkId] + ".chunk.css";
};